import { FC } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box
} from '@mui/material';
import { format } from 'date-fns';
import { WarrantyEvent } from 'src/models/order';
import { creditStatusMap, reasonMap } from './WarrantyEventModal';

interface WarrantyEventSectionProps {
  warrantyEvents: WarrantyEvent[];
  order?: {
    id: string;
    confirmationCode: string;
  };
}

const WarrantyEventSection: FC<WarrantyEventSectionProps> = ({
  warrantyEvents,
  order
}) => {
  if (warrantyEvents.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Order</TableCell>
              <TableCell>Headset</TableCell>
              <TableCell>Unit Retrieved</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Serial Number</TableCell>
              <TableCell>Batch Number</TableCell>
              <TableCell>Shipped Date</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Credit</TableCell>
              <TableCell>Sensors Replaced</TableCell>
              <TableCell>Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {warrantyEvents.map((warrantyEvent, index) => (
              <TableRow key={index}>
                <TableCell>
                  {(order ?? warrantyEvent.order)?.confirmationCode}
                </TableCell>
                <TableCell>
                  {warrantyEvent.headset ? warrantyEvent.headset.mac : 'N/A'}
                </TableCell>
                <TableCell>
                  {warrantyEvent.unitRetrieved ? 'Yes' : 'No'}
                </TableCell>
                <TableCell>
                  {warrantyEvent.warrantyCreated &&
                  new Date(
                    warrantyEvent.warrantyCreated.formatted
                  ).getFullYear() > 1970
                    ? format(
                        new Date(warrantyEvent.warrantyCreated.formatted),
                        'MMM dd, yyyy'
                      )
                    : 'N/A'}
                </TableCell>
                <TableCell>{warrantyEvent.serialNo}</TableCell>
                <TableCell>{warrantyEvent.batchNo || 'N/A'}</TableCell>
                <TableCell>
                  {warrantyEvent.warranteedUnitShippedDate &&
                  new Date(
                    warrantyEvent.warranteedUnitShippedDate.formatted
                  ).getFullYear() > 1970
                    ? format(
                        new Date(
                          warrantyEvent.warranteedUnitShippedDate.formatted
                        ),
                        'MMM dd, yyyy'
                      )
                    : 'N/A'}
                </TableCell>
                <TableCell>
                  {reasonMap[warrantyEvent.reason]?.name ?? 'N/A'} -{' '}
                  {reasonMap[warrantyEvent.reason]?.subReasons.find(
                    (sub) => sub.value === warrantyEvent.subReason
                  )?.name ?? 'N/A'}
                </TableCell>
                <TableCell>
                  {warrantyEvent.creditStatus
                    ? creditStatusMap[warrantyEvent.creditStatus]
                    : 'N/A'}
                </TableCell>
                <TableCell>
                  {warrantyEvent.haveSensorsBeenReplaced ? 'Yes' : 'No'}
                </TableCell>
                <TableCell>{warrantyEvent.notes || 'N/A'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default WarrantyEventSection;
